/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { Project }                 from '../project';
import { ProjectType }             from "@/models/project.type";
import { ProjectElement }          from './project.element';
import { ManifestElement }         from './manifest.element';
import { ProjectFactoryDecorator } from "@/models/project.factory.decorator";

/**
 *
 * @class LibraryProject
 *
 * @brief this project is just a collection of items.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
@ProjectFactoryDecorator('LibraryProject')
export class LibraryProject extends Project {

  /** standard constructor */
  constructor(name: string) {

    super(name, 'fas fa-toolbox');

    this.type  = ProjectType.Library;
    this.icon  = '<i class="fas fa-toolbox"></i>';
    this.facon = 'fas fa-toolbox';

    /* build up default structure */

    const a:    ProjectElement = new ManifestElement(this, '', this.root());
  }

  /** helper to use to for static global constructors (and factory registration) */
  static requireType() {
    console.log("requiring LibraryProject");
  }

}
